import { planCollectionNames } from '@smarty-nx/contentful'

export const ADDON_TYPES = {
  CASH: 'CASH',
  DATA: 'DATA',
  EU_DATA_PASS: 'EU_DATA_PASS',
  UK_DATA_PASS: 'UK_DATA_PASS',
}

export const ENDPOINT_STATUSES = {
  STATUS_UNSTARTED: 'STATUS_UNSTARTED',
  STATUS_REQUESTING: 'STATUS_REQUESTING',
  STATUS_SUCCESS: 'STATUS_SUCCESS',
  STATUS_ERROR: 'STATUS_ERROR',
}

export const GROUP_STATUSES = {
  VIEW_ONLY: 'view-only',
  NO_ACCESS: 'no-access',
  SAME_USER: 'same_user',
  CANNOT_INVITE: 'cannot_invite',
  USER_DOES_NOT_EXIST: 'user_does_not_exist',
  EXISTING: 'existing',
}

export const GROUP_INVITE_TYPES = {
  GROUP_NICKNAME: 'group-nickname',
  GROUP_ACCOUNT: 'group-account',
  GROUP_EXISTING: 'group-existing',
  STANDARD: 'standard',
  UNDER_SIXTEEN: 'under-sixteen',
  DEVICE: 'device',
}

export const PLAN_SLUGS = {
  UNLIMITED: 'unlimited',
}

export const PLAN_CATEGORIES = {
  DATA_DISCOUNT: 'data-discount',
  NO_DATA_DISCOUNT: 'no-data-discount',

  VOICE_SIM: 'voice-sim',
  DATA_DISCOUNT_SIM: 'data-discount-sim',
  DATA_ONLY_SIM: 'data-only-sim',
  PRELOADED_SIM: 'preloaded-sim',
}

export const PORTING_CONSTANTS = {
  PAC: 'PAC',
  STAC: 'STAC',
  GET_PAC: 'getPAC',
  GET_STAC: 'getSTAC',
  HAVE_PAC: 'havePAC',
  HAVE_STAC: 'haveSTAC',
}

export const PORT_OUT_STATUSES = {
  PORT_OUT_STATUS_UNKNOWN: 'unknown',
  PORT_OUT_STATUS_UNSTARTED: 'none',
  PORT_OUT_STATUS_PROCESSING: 'requested',
  PORT_OUT_STATUS_READY: 'completed',
  PORT_OUT_STATUS_ERROR: 'error',
}

export const RICH_DATA_STRINGS = {
  FAQ_ITEM_PROP: 'mainEntity',
  FAQ_ITEM_TYPE: 'https://schema.org/FAQPage',
  QUESTION_ITEM_TYPE: 'https://schema.org/Question',
  ANSWER_ITEM_TYPE: 'https://schema.org/Answer',
  ANSWER_ITEM_PROP: 'acceptedAnswer',
  TEXT_ITEM_PROP: 'text',
}

export const CONTENTFUL_TYPES = {
  ADDON_CAROUSEL: 'add-on-carousel',
  DISMISSIBLE_CARD: 'dismissible-card',
}

export const CAROUSEL_TYPES = {
  RECOMMENDED: 'recommended',
  DATA: 'data',
  UK_DATA_PASS: 'uk_data_pass',
  EU_DATA_PASS: 'eu_data_pass',
  OUT_OF_PLAN: 'out_of_plan',
  OUT_OF_PLAN_SECONDARY: 'out_of_plan_secondary',
}

export const VOUCHER_CODE_KEY = 'vc'

export const SWITCHING_INFO =
  'https://help.smarty.co.uk/en/collections/3866305-switching-to-smarty'
export const MAIN_FAQ = 'https://help.smarty.co.uk'
export const WHEN_TO_START_USING_SIM =
  'https://help.smarty.co.uk/en/articles/4227332-when-should-i-start-using-my-sim'

export const TERMS_LINK =
  'https://cdn.smarty.co.uk/files/SMARTY-Refer-a-Friend.pdf'
export const TERMS_LINK_UPDATE =
  'https://cdn.smarty.co.uk/files/SMARTY-Refer-a-Friend-T&C-Update.pdf'

export const SAME_ORIGIN_REFERER_MINIMUM_HISTORY_LENGTH = 3

export const PLAN_COLLECTION_TAGS = {
  [planCollectionNames.VOICE_PLANS]: 'Voice',
  [planCollectionNames.MONEY_BACK_PLANS]: 'Money Back',
  [planCollectionNames.DATA_ONLY_PLANS]: 'Data Only',
}

export const CHIP_TEXTS = {
  GROUP_DISCOUNT: 'GROUP DISCOUNT',
}

export const FAMILY_PLAN_SIMS_NUMBER_KEY = 'familyPlanSimsNumber'

export const MAX_FAMILY_PLAN_MEMBERS = 8

export const SIM_JOURNEY_TYPES = {
  SIM_IN_HAND_JOURNEY: 'sim_in_hand_journey',
  ONLINE_SIM_ORDER_JOURNEY: 'online_sim_order_journey',
}

export const MAX_ACTIVE_GROUP_MEMBERS_NUMBER = 7
export const MIN_ACTIVE_GROUP_MEMBERS_NUMBER = 2
